const BC_NAME = 'shefa-green-rate-limit-v1';

let channel;
let backoffUntilMs = 0;

function getChannel() {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) {
    channel = new BroadcastChannel(BC_NAME);
    channel.onmessage = (ev) => {
      if (ev?.data?.type === 'shefa-rate-limit' && typeof ev.data.until === 'number') {
        backoffUntilMs = Math.max(backoffUntilMs, ev.data.until);
      }
    };
  }
  return channel;
}

/** Call once at app bootstrap so tabs receive shared backoff signals. */
export function initRateLimitBroadcast() {
  getChannel();
}

/**
 * @param {number} retryAfterSec - Retry-After header value in seconds
 */
export function signalRateLimitBackoffFromSeconds(retryAfterSec) {
  const sec = Math.min(86400, Math.max(1, Math.floor(Number(retryAfterSec)) || 60));
  const until = Date.now() + sec * 1000;
  backoffUntilMs = Math.max(backoffUntilMs, until);
  try {
    getChannel()?.postMessage({ type: 'shefa-rate-limit', until });
  } catch {
    /* ignore */
  }
}

export function isRateLimitBackoffActive() {
  return Date.now() < backoffUntilMs;
}
